import axios from 'axios';
import sdata from './_/sdata'
import sname from './_/sname'

export default function (context, val) {
    let name = val;
    axios({
        url: '/tourclient/legend/getDefaultLegend',
        method: 'POST',
        data: 'request=' + JSON.stringify({
            ScreenName: sname(name)
        }),
    }).then(({data})=>{
        context.dispatch(name + '/set', sdata(data));
        
        context.state[name].rebind = false;
        setTimeout(() => {
            context.state[name].rebind = true;
        });
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}